<script setup lang="ts">
import { useOverlay } from '../../composables/useOverlay';
import Button from '../button/Button.vue';
import { computed, ref } from 'vue';

const overlay = useOverlay();

const imageLoaded = ref(false);

const currentImage = computed(() => overlay.lightbox.request?.images[overlay.lightbox.currentIndex] || '');

function close() {
  overlay.closeLightbox();
}

function next() {
  overlay.nextLightboxImage();
}

function prev() {
  overlay.prevLightboxImage();
}
</script>

<template>
  <Teleport to="body">
    <TransitionGroup
      name="fade"
      tag="div"
    >
      <div
        v-if="overlay.lightbox.request"
        class="fixed bg-black/60 flex justify-center items-center z-1000 inset-0 backdrop-blur-xs px-4"
        @click.self="close"
      >
        <div
          class="relative select-none max-w-[90vw] max-h-[90vh]"
          tabindex="0"
          @keydown.arrow-left.prevent="prev"
          @keydown.arrow-right.prevent="next"
          @keydown.esc.prevent="close"
        >
          <div
            v-if="imageLoaded === false"
            class="animate-pulse c-w-100 h-[50vh] bg-yellow-900/10 rounded-lg"
          />

          <div class="rounded-lg overflow-hidden">
            <img
              :src="currentImage"
              class="mx-auto my-0 block max-w-full max-h-full"
              alt="Lightbox Image"
              @load="imageLoaded = true"
            >
          </div>
        </div>
        <nav class="absolute bottom-4 flex gap-4 items-center">
          <div class="flex gap-4 items-center rounded-full bg-yellow-200">
            <Button
              severity="secondary"
              icon="mi-chevron-l"
              @click="prev"
            />
            <strong
              class="text-brown-800"
            >
              {{ overlay.lightbox.currentIndex + 1 }} / {{ overlay.lightbox.request.images.length }}
            </strong>
            <Button
              severity="secondary"
              icon="mi-chevron-r"
              @click="next"
            />
          </div>
          <Button
            severity="secondary"
            icon="mi-close"
            @click="close"
          />
        </nav>
      </div>
    </TransitionGroup>
  </Teleport>
</template>

<style scoped>
.fade-enter-active, .fade-leave-active { transition: opacity 0.2s ease-in-out, transform 0.2s ease-in-out; }
.fade-enter-from, .fade-leave-to { opacity: 0; transform: translateY(30px); }
</style>
